import SelectTableBehandelingSpecifiekeHypertensieveSpoedgevallen from "../../../../src/client/niv_acuteboekje/ui/SelectTableBehandelingSpecifiekeHypertensieveSpoedgevallen.js";
import * as React from 'react';
export default {
  SelectTableBehandelingSpecifiekeHypertensieveSpoedgevallen,
  React
};